import Base from './base'

export default class BelongsTo extends Base {
  constructor (model, name, options = {}) {
    super(model, name, options)

    this.key = options.key || `${this.name}_${this.primaryKey}`
  }

  getResult (record) {
    return this.associatedModel().collection.getById(record.get(this.key))
  }
}
